export default {
  myTrainingDetail_submit__num: '{voteQuantity, plural, =0 {no people has} =1 {one people has} other {# people have}} submitted',
  myTrainingDetail_teacher_score: 'Instructor rating: {teacherScore}',
  myTrainingDetail_content_score: 'Content rating: {contentScore}',
  myTrainingDetail_organization_score: 'Organization rating: {organizationScore}',
  myTrainingDetail_check_schedule: '1304Web-View schedule',
  myTrainingDetail_no_schedule: 'No schedule yet',
  myTrainingDetail_date_schedule: 'Day {i}',
  myTrainingDetail_teacher: 'Instructor:',
  myTrainingDetail_cancel_registration: 'Cancel registration for face-to-face course',
  myTrainingDetail_cancel_reason: 'Please enter the reason for cancellation',
  myTrainingDetail_submit_comment1308: '1308Web-Submit a discussion',
  myTrainingDetail_all_course: 'All courses',
  myTrainingDetail_open_time: 'Start Time:',
  myTrainingDetail_address_class: 'Location:',
  myTrainingDetail_lecturer: 'Instructor: ',
  myTrainingDetail_student_number: '{studentNumber} people in total is learning in this OMO class',
  myTrainingDetail_no_student_join: 'No one has signed up for this face-to-face course',
  myTrainingDetail_student_join_num: '{studentNumber} people has attended this OMO class',
  myTrainingDetail_reported_limited: 'Signed-up/Limit:',
  myTrainingDetail_registration_deadline: 'Time left for registration:',
  myTrainingDetail_failed_apply_reapply: 'Your registration has not been approved. Try again?',
  myTrainingDetail_failed_reason: 'Reason for registration rejection:',
  myTrainingDetail_registration_start: 'Registration starts in:',
  myTrainingDetail_registration_no_start: 'Registration is not open',
  myTrainingDetail_I_sign_up: 'I want to sign in',
  myTrainingDetail_full_registration: 'Full',
  myTrainingDetail_registration_ended: 'Registration has ended',
  myTrainingDetail_re_apply: 'Re-register',
  myTrainingDetail_registration_review: 'Pending approval',
  myTrainingDetail_concell_registration_review: 'Cancellation pending approval',
  myTrainingDetail_congratulations_graduation: 'Congratulation on completion!',
  myTrainingDetail_I_want_evaluate: 'Comment here',
  myTrainingDetail_check_resources1312: '1312Web-View resources',
  myTrainingDetail_remain_quantity: 'You have {remainQuantity, plural, =0 {no more chances} =1 {one more chance} other {# more chances}} to take the exam',
  myTrainingDetail_check_all1311: '1311Web-View All',
  myTrainingDetail_total_exam: 'All exams',
  myTrainingDetail_no_graduation_path: 'Background error. Graduation album path cannot be found',
  myTrainingDetail_check_graduation1313: '1313Web-View graduation album',
  myTrainingDetail_faceclass13: '13Web-Face-to-face course',
  myTrainingDetail_look_graduation_album: 'Check out your graduation album!' ,
  myTrainingDetail_graduation_album: 'Graduation album',
  myTrainingDetail_browser_not_support: 'Graduation album cannot be browsed on your browser',
  myTrainingDetail_no_permission_view: 'You have no permission to view',
  myTrainingDetail_images: 'Image',
  myTrainingDetail_files_type: 'Only attachment in word, excel, ppt, pdf, jpg, png formats can be uploaded',
  myTrainingDetail_files_upload_limit: 'Upload up to 5 attachments',
  myTrainingDetail_files_size_limit: 'Size of {fileObj} file exceeds 20M. Please re-upload',
  myTrainingDetail_files_empty_limit: 'File content cannot be empty',
  myTrainingDetail_files_value_limit: 'You can only enter up to 10000 words',
  myTrainingDetail_enclosure: 'Attachment:',
  myTrainingDetail_select: 'Select',
  myTrainingDetail_file_upload_limits: '(You can upload up to 5 attachments in word, excel, ppt, pdf, jpg, png format. File size cannot exceed 20M.)' ,
  myTrainingDetail_all_live: 'All lives',
  myTrainingDetail_Live_time: 'Live time:',
  myTrainingDetail_anchor_name: 'Anchor:',
  myTrainingDetail_all_questionnaires: 'All forms',
  myTrainingDetail_no_honor_list: 'No honor list yet',
  myTrainingDetail_submit_comment1303: '1303Web-Submit an evaluation',
  myTrainingDetail_go_comment_pages: '1302Web-Go to evaluation page',
  myTrainingDetail_submit_comment: 'Submit an evaluation',
  myTrainingDetail_face_class_comment: 'Face-to-face course evaluation',
  myTrainingDetail_please_comment: 'Please evaluate the face-to-face course',
  myTrainingDetail_Instructor_rating: 'Instructor rating',
  myTrainingDetail_content_rating: 'Content rating',
  myTrainingDetail_org_rating: "Organization rating",
  myTrainingDetail_rate_placeholder: "Write some comments about the class (optional)",
  myTrainingDetail_my_rate: 'My rating: ',
  myTrainingDetail_submit_success: 'Review submitted successfully',
  myTrainingDetail_make_online_courses: "Produced Courses",
  myTrainingDetail_individual: "pcs",
  myTrainingDetail_Live_broadcast: 'Anchor live',
  myTrainingDetail_face_class_teach: 'OMO Trainings',
  myTrainingDetail_my_lecture_overview: 'Overview of my teaching',
  myTrainingDetail_no_learn_resource: 'You have not created learning resource',
  myTrainingDetail_my_live_broadcast: 'Live I host',
  myTrainingDetail_my_teach_faceclass: 'Face-to-face courses I teach',
  myTrainingDetail_deadline: 'Time left for sign-in:',
  myTrainingDetail_upload: 'Upload attachments:',
  myTrainingDetail_voteQuantity: '{voteQuantity, plural, =0 {no people has} =1 {one people has} other {# people have}} submitted',
  myTrainingDetail_teacherScore: 'Instructor score: {teacherScore, plural, =0 {no points.} =1 {one point.} other {# points.}}',
  myTrainingDetailcontentScore: 'Content rating: {contentScore}',
  myTrainingDetail_organizationScore: 'Organization score: {organizationScore, plural, =0 {no points.} =1 {one point.} other {# points.}}',
  myTrainingDetail_score: '{score, plural, =0 {no point.} =1 {one point.} other {# points.}}',
}
